import React, { useState } from "react";

//Material Icons
import {
  Add,
  Delete,
  Discount,
  ExpandLess,
  ExpandMore,
  Remove,
} from "@mui/icons-material";

//UI Material
import {
  Button,
  Chip,
  IconButton,
  Stack,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";

export default function QuoteSummaryRow({ product, data, setData, currency }) {
  // ==========> Component States <==========
  const [showDetails, setShowDetails] = useState(false);

  // ==========> Component States <==========
  //Function to delete product from cart
  const handleDeleteProduct = () => {
    const updatedData = data.filter((item) => item.id !== product.id);
    setData(updatedData);
  };

  //Function to handle product increment in cart
  const handleProductIncrement = (dataArray, productId) => {
    let updatedDataArray = [];
    for (const product of dataArray) {
      if (product.id === productId) {
        product.quantity++;
      }
      updatedDataArray.push(product);
    }
    setData(updatedDataArray);
  };

  //Function to handle product decrement in cart
  const handleProductDecrement = (dataArray, productId) => {
    let updatedDataArray = [];
    for (const product of dataArray) {
      if (product.quantity > 1) {
        if (product.id === productId) {
          product.quantity -= 1;
        }
        updatedDataArray.push(product);
        setData(updatedDataArray);
      } else {
        handleDeleteProduct();
      }
    }
  };

  // ==========> Component <==========
  return (
    <TableRow>
      <TableCell colSpan={1}>
        <Stack
          justifyContent="space-between"
          alignItems="flex-start"
          spacing={1}
        >
          <Stack
            sx={{ width: "100%" }}
            justifyContent="space-between"
            alignItems="flex-start"
            direction="row"
          >
            <Stack spacing={1}>
              <Typography>{product.productName}</Typography>

              <Stack direction="row" alignItems="center" spacing={1}>
                <IconButton
                  size="small"
                  onClick={() => {
                    handleProductDecrement(data, product.id);
                  }}
                >
                  <Remove />
                </IconButton>
                <Typography>{product.quantity}</Typography>
                <IconButton
                  size="small"
                  onClick={() => {
                    handleProductIncrement(data, product.id);
                  }}
                >
                  <Add />
                </IconButton>
                {product.discountPercentage > 0 && (
                  <Chip
                    icon={<Discount sx={{ fontSize: "15px" }} />}
                    label={`${product.discountPercentage}%`}
                    color="warning"
                  />
                )}
              </Stack>
            </Stack>

            <Stack
              alignItems="flex-start"
              justifyContent="flex-end"
              direction="row"
              spacing={1}
            >
              <Stack alignItems="flex-end" textAlign="right">
                <Typography fontWeight="bold">
                  {`${currency === "USD" ? "$" : "₡"}${Number(
                    product.price * product.quantity
                  ).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}`}
                </Typography>

                <Stack direction="row" spacing={0.5}>
                  <Typography>c/u</Typography>
                  <Typography>{`${currency === "USD" ? "$" : "₡"}${Number(
                    product.price
                  ).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}`}</Typography>
                </Stack>
              </Stack>

              <IconButton onClick={handleDeleteProduct}>
                <Delete />
              </IconButton>
            </Stack>
          </Stack>

          <Button
            variant="text"
            sx={{ color: "secondary" }}
            endIcon={showDetails ? <ExpandLess /> : <ExpandMore />}
            onClick={() => {
              setShowDetails(!showDetails);
            }}
          >
            Ver detalles
          </Button>

          {showDetails && <Typography>{product.specifications}</Typography>}
        </Stack>
      </TableCell>
    </TableRow>
  );
}
